import { Component, OnInit } from '@angular/core';
import { StorageService } from '../../shared/storage.service';
import { CommonService } from '../../shared/common.service';
import { ActivatedRoute, Router } from '@angular/router';
import { UserLayoutService } from '../../layouts/user-layout/user-layout.service';
import { AbstractControl, FormArray, FormBuilder, FormGroup, ValidationErrors, ValidatorFn, Validators } from '@angular/forms';
import { FooterService } from '../../components/footer/footer.service';
import { HttpClient } from '@angular/common/http';
import { loadStripe, Stripe, StripeElements, StripeCardElement } from '@stripe/stripe-js';
import { OrganizationEnumModel } from '../../shared/constant/organization.model';
declare const $: any;
const countryData = require('../country-code.json');

@Component({
  selector: 'app-booking-review',
  templateUrl: './booking-review.component.html',
  styleUrls: ['./booking-review.component.css']
})
export class BookingReviewComponent implements OnInit {
  bookingId: string = '';
  PackageId: string = '';
  bookingNo: string = '';
  promoCodeId: any;
  promoCode: any;
  discountPercentage: any;
  promoMessage: string = '';
  promoMessageClass: string = '';
  adults: any;
  children: any;
  seniorCitizen: any;
  ReviewbookingForm: FormGroup;
  contactDetailsForm: FormGroup;
  bookingFormSubmitted: boolean = false;
  userId: any;
  guestUser: boolean;
  reviewBookingDetails: any = [];
  currentBookingDetails: any = [];
  travelerInfoSuccess: boolean = false;
  useForPrimary: boolean = true;
  countries: any[] = [];
  countryData = countryData;
  totalTravelers: number;
  totalPerson: number;
  stripe!: Stripe;
  elements!: StripeElements;
  card!: StripeCardElement;
  clientSecret!: string;
  cardDetails: any = null;
  package_summary_proceed_payment_btn: boolean = false;
  package_summary_payment_details_tax: boolean = false;
  EnableNeedHelpInCheckout: boolean = false;
  constructor(private router: Router,
    private route: ActivatedRoute,
    public storageService: StorageService,
    public commonService: CommonService,
    public userLayoutService: UserLayoutService,
    private fb: FormBuilder,
    private footerService: FooterService,
    private http: HttpClient,
  ) { }

  async ngOnInit(): Promise<void> {
    const organizationAttributes = localStorage.getItem('organizationAttributes');

    if (organizationAttributes) {
      const attributesList = JSON.parse(organizationAttributes);
      attributesList.find((attr: any) => { 
        if(attr.attributeName === OrganizationEnumModel.package_summary_proceed_payment_btn){
          this.package_summary_proceed_payment_btn = attr.value;
        } 
        if(attr.attributeName === OrganizationEnumModel.package_summary_payment_details_tax){
          this.package_summary_payment_details_tax = attr.value;
        } 
        if(attr.attributeName === OrganizationEnumModel.EnableNeedHelpInCheckout){
          this.EnableNeedHelpInCheckout = attr.value;
        } 
      });
    }
    this.userId = localStorage.getItem("_id");
    let isBooking = localStorage.getItem('bookingDetails');
    if (!isBooking) {
      this.navigateToHome();
    }
    this.guestUser = this.userId === null;
    this.footerService.hideFooter();
    this.route.queryParams.subscribe(params => {
      this.PackageId = params['PackageId'];
      this.bookingId = params['bookingID'];
      this.bookingNo = params['bookingNo'];
      this.adults = params['adults'];
      this.children = params['children'];
      this.seniorCitizen = params['seniorCitizen'];
    });

    this.defaultReviewBookingForm();
    this.defaultContactDetailsForm();
    this.getReviewBookingDetailsById();
    this.getCurrentBookingDetailsDataById();
    this.fetchCountries();
    this.setUserForPrimary();
    // Load Stripe
    this.stripe = await loadStripe(this.commonService.stripePublishKey);

    // Create Stripe Elements
    this.elements = this.stripe.elements();

    const cardOptions = {
      style: {
        base: {
          fontSize: '16px',
          color: '#32325d',
          lineHeight: '24px',
          letterSpacing: '0.025em',
          fontFamily: 'Arial, sans-serif',
          iconColor: '#c4f0ff',
          '::placeholder': {
            color: '#aab7c4',
          },
        },
      },
      hidePostalCode: true, // Hide the ZIP code field
    };
    // Create a card element
    this.card = this.elements.create('card', cardOptions);
    this.card.mount('#card-element');

    this.card.on('change', (event) => {
      const displayError = document.getElementById('card-errors');
      if (event.error) {
        displayError!.textContent = event.error.message;
      } else {
        displayError!.textContent = '';
      }
    });
  }
  async showCardDetails() {
    // Validate and get card details on button click
    const paymentMethodResult = await this.stripe.createPaymentMethod({
      type: 'card',
      card: this.card,
    });

    if (paymentMethodResult.error) {
      // Handle error if card input is incomplete or invalid
      console.error('Error retrieving card details:', paymentMethodResult.error);
      alert(paymentMethodResult.error.message);
      return;
    }

    const paymentMethod = paymentMethodResult.paymentMethod;

    // Store card details for display
    this.cardDetails = {
      brand: paymentMethod.card?.brand,
      last4: paymentMethod.card?.last4,
      exp_month: paymentMethod.card?.exp_month,
      exp_year: paymentMethod.card?.exp_year,
    };

    // console.log('Card Details:', this.cardDetails);
  }
  fetchCountries() {
    this.http.get<any[]>('https://restcountries.com/v3.1/all').subscribe(
      (data) => {
        this.countries = data.map((country) => {
          return {
            name: country.name.common,
            dialCode: `${country.idd?.root}${country.idd?.suffixes ? country.idd.suffixes[0] : ''}`,
            flag: country.flags.png,
          };
        });
      },
      (error) => {
      }
    );
  }

  searchByName(term: string, item: any) {
    return item.name.toLowerCase().includes(term.toLowerCase()) || item.dial_code.toLowerCase().includes(term.toLowerCase()) || item.code.toLowerCase().includes(term.toLowerCase());
  }

  defaultContactDetailsForm() {
    this.contactDetailsForm = this.fb.group({
      name: ['', Validators.required],
      email: ['', [Validators.required, this.customEmailValidator()]],
      countryCode: ['+1', Validators.required],
      contactNumber: ['', [Validators.required, Validators.pattern('^[0-9]{10}$')]],
    });
    this.bookingFormSubmitted = false;
  }

  customEmailValidator(): ValidatorFn {
    return (control: AbstractControl): ValidationErrors | null => {
      const emailPattern = /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/;
      const isValidEmail = emailPattern.test(control.value);
      return isValidEmail ? null : { 'invalidEmail': true };
    };
  }

  mobilenumberInput(event: any, formName: string, controlName: string): void {
    const input = event.target;

    // Allow only numeric values (0-9)
    input.value = input.value.replace(/[^0-9]/g, '');

    // Update the form control value
    this[formName].patchValue({
      [controlName]: input.value || null,
    });
  }
  
  textInput(event: any, formName: string, controlName: string): void {
    const input = event.target;
    input.value = input.value.replace(/[^a-zA-Z ]/g, '');

    if (this[formName] && this[formName].patchValue) {
      this[formName].patchValue({
        [controlName]: input.value || null,
      });
    }
    this.setUserForPrimary();
  }

  setUserForPrimary() {    
    let userData = JSON.parse(localStorage.getItem("LoginUserData"));
    if (this.useForPrimary && this.travelerInfo.length > 0) {
      if(userData) {
        // console.log(userData);
        const contactName = userData.firstName + ' ' + userData.lastName;
        this.travelerInfo.controls[0].patchValue({
          name: contactName,
        });
      } else {
        const contactName = this.contactDetailsForm.get('name')?.value || '';
        this.travelerInfo.controls[0].patchValue({
          name: contactName,
        });
      }
    } else {
      this.travelerInfo.controls[0].patchValue({
        name: '',
      });
    }
  }  

  trimWhitespace(event: any): void {
    const input = event.target;
    input.value = input.value.replace(/\s+/g, '');
  }

  calculateDiscountedPrice() {
    if (this.discountPercentage < 0 || this.discountPercentage > 100) {
      throw new Error("Discount percentage must be between 0 and 100.");
    }

    const discountAmount = (this.reviewBookingDetails.subTotal * this.discountPercentage) / 100;

    this.reviewBookingDetails.discount = parseFloat(discountAmount.toFixed(2));
    this.reviewBookingDetails.discountedSubTotal = parseFloat((this.reviewBookingDetails.subTotal - discountAmount).toFixed(2));
    this.reviewBookingDetails.discountedTax = parseFloat(((this.reviewBookingDetails.discountedSubTotal * this.commonService.taxRatio) / 100).toFixed(2));
    this.reviewBookingDetails.discountedTotal = parseFloat((this.reviewBookingDetails.discountedSubTotal + this.reviewBookingDetails.discountedTax).toFixed(2));
  }

  cancelPromoCode() {
    this.promoCode = '';
    this.promoCodeId = '';
    this.discountPercentage = 0;
    this.promoMessage = null;
    this.promoMessageClass = null;
    this.getReviewBookingDetailsById();
  }

  defaultReviewBookingForm() {
    this.bookingFormSubmitted = false;
    this.travelerInfoSuccess = false;

    this.totalTravelers = (parseInt(this.adults) + parseInt(this.children));
    this.ReviewbookingForm = this.fb.group({
      travelerInfo: this.fb.array([])  // FormArray to store travelers' details
    });

    this.addTravelers(this.adults, 'Adult');
    this.addTravelers(this.children, 'Child');
    // this.addTravelers(this.seniorCitizen);
    // console.log(this.travelerInfo.controls);

  }

  getReviewBookingDetailsById() {

    this.userLayoutService.getBookingDetailsById(this.bookingId).subscribe((Response: any) => {

      if (Response.code == 1) {
        this.reviewBookingDetails = Response.data;
      }
      else {
        // this.router.navigate(['home']);
      }
    }, (error) => {
    });
  }

  getCurrentBookingDetailsDataById() {

    this.userLayoutService.getBookingDetailsByBookingId(this.bookingId).subscribe((Response: any) => {

      if (Response.code == 1) {
        this.currentBookingDetails = Response.data;
        this.totalPerson = (this.currentBookingDetails.adults + this.currentBookingDetails.children + this.currentBookingDetails.toddler)
        this.updateTravelerInfoFromFamily();
        if (this.currentBookingDetails.guestDetails) {
          this.contactDetailsForm.patchValue({
            name: this.currentBookingDetails.guestDetails.guestName || '',
            email: this.currentBookingDetails.guestDetails.email || '',
            countryCode: this.currentBookingDetails.guestDetails.countryCode || '+1',
            contactNumber: this.currentBookingDetails.guestDetails.contactNo || ''
          });
        }
        // console.log(this.currentBookingDetails)

        if (this.currentBookingDetails?.familyInformation.length == this.totalTravelers) {
          this.travelerInfoSuccess = true;
          // this.bookingFormSubmitted = true;
        }
        else {
          this.travelerInfoSuccess = false;
          // this.bookingFormSubmitted = false;
        }

      }
      else {
        // this.router.navigate(['home']);
      }
    }, (error) => {
    });
  }

  // Getter for travelerInfo FormArray
  get travelerInfo(): FormArray {
    return this.ReviewbookingForm.get('travelerInfo') as FormArray;
  }

  // Method to create and add a FormGroup to the FormArray for each traveler
  addTravelers(count: number, person: any): void {
    for (let i = 0; i < count; i++) {
      const travelerFormGroup = this.fb.group({
        bookingId: [this.bookingId],
        name: ['', Validators.required],
        age: ['', [Validators.required, this.ageValidator(person)]],
        gender: ['', Validators.required],
        person: person,
        count: i + 1
      });
      this.travelerInfo.push(travelerFormGroup);
    }
  }

  ageValidator(person: string): ValidatorFn {
    return (control: AbstractControl): ValidationErrors | null => {
      const age = control.value;
      if (person === 'Adult' && (age < 12 || age > 120)) {
        return { ageInvalid: true };
      }
      if (person === 'Child' && (age < 5 || age > 11)) {
        return { ageInvalid: true };
      }
      return null;
    };
  }

  filterNonNumeric(event: Event, traveler: FormGroup): void {
    const inputElement = event.target as HTMLInputElement;
    const numericValue = inputElement.value.replace(/\D/g, '');
    traveler.get('age')?.setValue(numericValue);
  }
  
  filterTextInput(event: Event, traveler: FormGroup): void {
    const inputElement = event.target as HTMLInputElement;
    const numericValue = inputElement.value.replace(/[^a-zA-Z ]/g, '');
    traveler.get('name')?.setValue(numericValue);
  }

  updateTravelerInfoFromFamily(): void {
    const familyInfo = this.currentBookingDetails.familyInformation;

    // Ensure familyInfo exists and there are travelers to map
    if (familyInfo && familyInfo.length > 0) {
      familyInfo.forEach((familyMember, index) => {
        // If the travelerInfo form array has a corresponding form group, update it
        if (this.travelerInfo.at(index)) {
          const travelerFormGroup = this.travelerInfo.at(index);
          // console.log("*", travelerFormGroup);

          // Patch values into the form group
          travelerFormGroup.patchValue({
            name: familyMember.name,
            age: familyMember.age,
            gender: familyMember.gender
          });
        }
      });
    }
  }

  editDetails(): void {
    this.router.navigate(['packages-details'], {
      queryParams: {
        PackageId: this.PackageId,
      }
    });
  }

  // Method to save form data
  confirmTravelers(): void {
    this.bookingFormSubmitted = true;

    if (this.ReviewbookingForm.valid) {

      if (this.guestUser) {
        // console.log("guest user");
        if (this.contactDetailsForm.valid) {
          const travelers = this.ReviewbookingForm.value.travelerInfo.map((traveler: any, index: number) => ({
            order: index + 1,
            name: traveler.name,
            age: traveler.age,
            gender: traveler.gender
          }));

          let preBookingObj = {
            bookingId: this.bookingId,
            guestName: this.contactDetailsForm.get('name')?.value,
            guestEmail: this.contactDetailsForm.get('email')?.value,
            guestCountry: this.contactDetailsForm.get('countryCode')?.value,
            guestMobilenumber: this.contactDetailsForm.get('contactNumber')?.value,
            travelers: travelers
          };
          // console.log(preBookingObj);

          this.userLayoutService.updateTravelerInfoById(preBookingObj).subscribe(
            (response: any) => {
              if (response.code === 1) {
                if(this.travelerInfoSuccess) {
                  this.commonService.notifier.notify('success', "Booking Information Updated Successfully");
                } else {
                  this.commonService.notifier.notify('success', "Booking Information Saved Successfully");
                }
                
                this.travelerInfoSuccess = true;
                this.getCurrentBookingDetailsDataById();
              } else {
                this.commonService.notifier.notify('error', response.message);
              }
            },
            (error) => {
              console.error('API Error:', error);
              this.commonService.notifier.notify('error', error);
            }
          );
        }
      } else {
        const travelers = this.ReviewbookingForm.value.travelerInfo.map((traveler: any, index: number) => ({
          order: index + 1,
          name: traveler.name,
          age: traveler.age,
          gender: traveler.gender
        }));

        let preBookingObj = {
          bookingId: this.bookingId,
          travelers: travelers
        };

        this.userLayoutService.updateTravelerInfoById(preBookingObj).subscribe(
          (response: any) => {
            if (response.code === 1) {
              this.commonService.notifier.notify('success', response.message);
              this.travelerInfoSuccess = true;
              this.getCurrentBookingDetailsDataById();

            } else {
              this.commonService.notifier.notify('error', response.message);
            }
          },
          (error) => {
            console.error('API Error:', error);
            this.commonService.notifier.notify('error', error);
          }
        );
      }
    } else {
    }
  }

  applyPromo() {
    // this.getReviewBookingDetailsById();
    let promoObj = {
      promoCode: this.promoCode,
      packageId: this.PackageId,
      bookingId: this.bookingId,
    };
    this.userLayoutService.applyPromoCode(promoObj).subscribe(
      (response: any) => {
        if (response.code === 1) {
          // this.discountPercentage = 0;
          this.reviewBookingDetails.promoCode = this.promoCode;
          this.promoCodeId = response?.data?.promoId;
          this.discountPercentage = response.data.discountPercentage;
          this.calculateDiscountedPrice()
          this.promoMessage = "Promo code applied";
          this.promoMessageClass = "success";
        } else {
          this.discountPercentage = 0;
          this.getReviewBookingDetailsById();
          this.promoMessage = "Promo code invalid or expired !";
          this.promoMessageClass = "error";
        }
      },
      (error) => {
        this.discountPercentage = 0;
        this.getReviewBookingDetailsById();
        this.promoMessage = "Promo code invalid or expired !";
        this.promoMessageClass = "error";
      }
    );
  }

  onEnquiry() {
    this.travelerInfoSuccess = true;
    localStorage.removeItem('bookingDetails');
    let paymentObj = {
      bookingId: this.bookingId,
      promoId: this.promoCodeId,
      promoCode: this.promoCode,
      discountPercentage: this.discountPercentage,
      discount: this.reviewBookingDetails.discount,
      discountedPrice: this.reviewBookingDetails.discountedSubTotal,
      taxAmount: this.reviewBookingDetails.discountedTax,
      totalAmount: this.reviewBookingDetails.discountedTotal
    };

    this.userLayoutService.standardPackageInquiry(paymentObj).subscribe(
      (response: any) => {
        if (response.code === 1) {
          // this.commonService.notifier.notify('success', response.message);
          this.travelerInfoSuccess = true;
          localStorage.removeItem('bookingDetails');
        } else {
          this.commonService.notifier.notify('error', response.message);
        }
      },
      (error) => {
        console.error('API Error:', error);
        this.commonService.notifier.notify('error', error);
      }
    );
  }

  navigateToBookings() {
    this.router.navigate(['/bookings']);
  }
  navigateToHome() {
    this.router.navigate(['/home']);
  }
  // handlePayment() {
  //   let paymentObj = {
  //     amount: 5000
  //   };
  //   this.userLayoutService.paymentIntent(paymentObj).subscribe(
  //     async (response: any) => {
  //       const clientSecret = response.clientSecret;

  //       const { error, paymentIntent } = await this.stripe.confirmCardPayment(clientSecret, {
  //         payment_method: {
  //           card: this.card,
  //           billing_details: {
  //             name: 'Customer Name',
  //           },
  //         },
  //       });

  //       if (error) {
  //         console.error('Payment error:', error);
  //         alert('Payment failed. Please try again.');
  //       } else if (paymentIntent?.status === 'succeeded') {
  //         console.log('Payment successful:', paymentIntent);
  //         alert('Payment successful!');
  //       }
  //     },
  //     (error) => {
  //       console.error('Error creating payment intent:', error);
  //       alert('Failed to create payment intent.');
  //     }
  //   );
  // }

  // async submitCardDetails() {
  //   // Create payment method using the card details entered by the user
  //   const paymentMethodResult = await this.stripe.createPaymentMethod({
  //     type: 'card',
  //     card: this.card,
  //   });

  //   if (paymentMethodResult.error) {
  //     console.error('Error retrieving card details:', paymentMethodResult.error);
  //     alert(paymentMethodResult.error.message);
  //     return;
  //   }

  //   const paymentMethod = paymentMethodResult.paymentMethod;

  //   // Capture card details and display them or use them for further payment processing
  //   console.log('Card Details:', {
  //     brand: paymentMethod.card?.brand,
  //     last4: paymentMethod.card?.last4,
  //     exp_month: paymentMethod.card?.exp_month,
  //     exp_year: paymentMethod.card?.exp_year,
  //   });
  //   $('#cardDetailsModal').modal('hide');
  //   alert('Card details captured successfully!');
  // }

  // async submitCardDetails() {
  //     if (!this.clientSecret) {
  //       console.error('Client secret is not available');
  //       return;
  //     }

  //     // Confirm the payment using the client secret and card details
  //     const paymentResult = await this.stripe.confirmCardPayment(this.clientSecret, {
  //       payment_method: {
  //         card: this.card,
  //       },
  //     });

  //     if (paymentResult.error) {
  //       // Handle payment error (e.g., card declined)
  //       console.error('Payment failed:', paymentResult.error.message);
  //       alert(paymentResult.error.message);
  //     } else {
  //       // Payment is authorized but not captured yet
  //       if (paymentResult.paymentIntent?.status === 'requires_capture') {
  //         console.log('Payment authorized but not captured yet');
  //         alert('Payment is authorized and on hold!');
  //       } else {
  //         console.log('Payment failed or completed');
  //       }
  //     }
  //   }

  submitCardDetails() {
    if (this.promoCode && this.promoCodeId) {
      let paymentObj = {
        bookingId: this.bookingId,
        promoId: this.promoCodeId || null,
        promoCode: this.promoCode || null,
        discountPercentage: this.discountPercentage,
        discount: this.reviewBookingDetails.discount,
        discountedPrice: this.reviewBookingDetails.discountedSubTotal,
        taxAmount: this.reviewBookingDetails.discountedTax,
        totalAmount: this.reviewBookingDetails.discountedTotal
      };
  
      this.userLayoutService.updateBookingDetails(paymentObj).subscribe(
        (response: any) => {
          if (response.code === 1) {
            this.paymentIntent();
          }
        },
        (error) => {
          // console.error('API Error:', error);
          this.commonService.notifier.notify('error', error);
        }
      );
    } else {
      this.paymentIntent();
    }
  }

  paymentIntent() {
    const paymentObj = {
      bookingId: this.bookingId,
      amount: (this.reviewBookingDetails.discountedTotal ? this.reviewBookingDetails.discountedTotal : this.reviewBookingDetails.total) * 100,
      currency: "usd",
    };

    // Call the service to create a PaymentIntent
    this.userLayoutService.paymentIntent(paymentObj).subscribe(
      async (response: any) => {
        // Retrieve the client secret from the backend response
        const clientSecret = response.clientSecret;

        if (!clientSecret) {
          console.error('Client secret is not available.');
          alert('Failed to initiate payment. Please try again.');
          return;
        }

        // Confirm the payment using the client secret and card details
        const { error, paymentIntent } = await this.stripe.confirmCardPayment(clientSecret, {
          payment_method: {
            card: this.card, // Card details collected via Stripe Elements
            billing_details: {
              name: this.bookingId, // Replace with actual customer name if available
            },
          },
        });

        if (error) {
          // Handle payment error
          console.error('Payment error:', error);
          $('#cardDetailsModal').modal('hide');
          $('#retryPayment').modal('show');

        } else if (paymentIntent?.status === 'requires_capture') {
          // Payment succeeded
          // console.log('Payment successful:', paymentIntent);
          this.savepaymentDetails(paymentIntent);
          $('#cardDetailsModal').modal('hide');

        } else {
          // console.log('Payment unexpected:', paymentIntent);
          $('#cardDetailsModal').modal('hide');
          $('#retryPayment').modal('show');
        }
      },
      (error) => {
        // Handle errors in creating PaymentIntent
        // console.error('Error creating payment intent:', error);
        alert('Failed to create payment intent. Please try again.');
      }
    );
  }

  savepaymentDetails(paymentIntent: any) {
    const paymentObj = {
      bookingId: this.bookingId,
      type: "card",
      transactionId: paymentIntent.id,
      currency: "usd",
      amount: (this.reviewBookingDetails.discountedTotal ? this.reviewBookingDetails.discountedTotal : this.reviewBookingDetails.total) * 100
    };
    this.userLayoutService.paymentProcess(paymentObj).subscribe(
      (response: any) => {
        if (response.code === 1) {
          // this.commonService.notifier.notify('success', response.message);
          this.travelerInfoSuccess = true;
          localStorage.removeItem('bookingDetails');
          $('#proceedToPayment').modal('show');
        } else {
          this.commonService.notifier.notify('error', response.message);
        }
      },
      (error) => {
        console.error('API Error:', error);
        this.commonService.notifier.notify('error', error);
      }
    );
  }

  ClearCardDetails() {
    // Reset the card details when modal is opened
    if (this.card) {
      this.card.clear(); // Clear the Stripe card input
    }

    // Optionally, reset any error messages
    const cardErrors = document.getElementById('card-errors');
    if (cardErrors) {
      cardErrors.textContent = ''; // Clear error message
    }
  }
}
